import dayjs from "dayjs";

const dateShortcuts = [
  {
    label: "Today",
    getValue: () => [dayjs(), dayjs()],
  },
  {
    label: "Yesterday",
    getValue: () => [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
  },
  {
    label: "Last 7 Days",
    getValue: () => [dayjs().subtract(6, "day"), dayjs()],
  },
  {
    label: "This Month",
    getValue: () => [dayjs().startOf("month"), dayjs()],
  },
  {
    label: "Last Month",
    getValue: () => [
      dayjs().subtract(1, "month").startOf("month"),
      dayjs().subtract(1, "month").endOf("month"),
    ],
  },
  {
    label: "Last 30 Days",
    getValue: () => [dayjs().subtract(30, "day"), dayjs()],
  },
];

export default dateShortcuts;